<div [formGroup]="form">
    <div class="flex-row-generic">
        <!-- External Id Control -->
        <div class="form-group flex-item-two-columns">
            <label for="{{ baseId }}-id" translate>ID</label>
            <input
                id="{{ baseId }}-id"
                class="form-control"
                [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }"
                type="text"
                [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
                formControlName="externalId"
            />
            <div
                *ngIf="showErrors(externalIdControl, isSubmitted)"
                id="{{ baseId }}-warning-text-external-id"
                class="incorrect-input"
                translate
                >
                {{ externalIdControl.errors | fcListValidation : 'External Id' }}
            </div>
        </div>
        <!-- External Id Control -->

        <!-- Name Control -->
        <div class="form-group flex-item-two-columns">
            <label for="{{ baseId }}-name" translate>Name</label>
            <div class="dropdown">
            <input
                id="{{ baseId }}-name"
                class="form-control"
                [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }"
                type="text"
                [maxlength]="fcListValidation.validations.Name.MaxLength"
                formControlName="name"
            />
            </div>
            <div *ngIf="showErrors(nameControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-name" translate>
            {{ nameControl.errors | fcListValidation : 'Name' }}
            </div>
        </div>
        <!-- Name Control -->
    </div>

    <div class="flex-row-generic">
        <!-- Toolbar Text Control -->
        <div class="form-group flex-item-two-columns">
            <label for="{{ baseId }}-toolbar-text" translate>Toolbar Text</label>
            <div class="dropdown">
                <input
                    id="{{ baseId }}-toolbar-text"
                    class="form-control"
                    [ngClass]="{ error: showErrors(toolbarTextControl, isSubmitted), 'required': isRequired(toolbarTextControl) }"
                    type="text"
                    [maxlength]="fcListValidation.validations.ToolbarText.MaxLength"
                    formControlName="toolbarText"
                />
            </div>
        </div>
        <!-- Toolbar Text Control -->

        <!-- Text Color Control -->
        <div class="form-group flex-item-two-columns">
            <ap-fc-text-color-list
                [baseId]="baseId"
                [form]="form"
                [textColorControl]="nameControl"
                [textColorValue]="nameControl.value"
                [color]="colorControl.value"
                >
            </ap-fc-text-color-list>
        </div>
        <!-- Text Color Control -->
    </div>

    <!-- Notes Control -->
    <div class="form-group full-control flex-item-two-columns">
        <label for="{{ baseId }}-notes" translate>Notes</label>
        <textarea
            class="form-control"
            [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
            id="{{ baseId }}-notes"
            [maxlength]="fcListValidation.validations.Notes.MaxLength"
            formControlName="notes"
            rows="3"
        >
        </textarea>
        <div *ngIf="showErrors(notesControl, isSubmitted)" id="{{ baseId }}-warning-text-notes" class="incorrect-input" translate>
            {{ notesControl.errors | fcListValidation : 'Notes' }}
        </div>
    </div>
    <!-- Notes Control -->

    <div class="checkbox-btn-group">
        <!-- Inactive and User Defined checkboxes -->
        <div class="checkbox-group">
            <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate> Inactive </mat-checkbox>
            <mat-checkbox id="{{ baseId }}-user-defined-checkbox" formControlName="userDefined" translate> User Defined </mat-checkbox>
        </div>
        <!-- Inactive and User Defined checkboxes -->
        <button
            class="btn btn-light btn-flush-left"
            type="button"
            [disabled]="isNewMode"
            translate>
        Import...
        </button>
    </div>
  </div>
